<template>
  <div class="generation-wrap">
    
    <div class="left-content">
      <div class="data-location" id="Content">
        <div class="title">
          <div class="text">
            数据生成
          </div>
          <div class="subText">
            DATA GENERATION
          </div>
        </div>
        <transition appear appear-to-class="animate__animated animate__zoomIn">
          <div class="content">
            
            <div class="item">
              <div class="icon">
                <img src="./../../../assets/image/datasource/money.png" alt="">
              </div>
              <div class="amount">
                <span>
                  <countTo :startVal='0' :endVal='92' :duration='3000'></countTo>
                  ~
                  <countTo :startVal='0' :endVal='280' :duration='3000'></countTo>
                </span>
                <span class="unit">
                  元
                </span>
              </div>
              <div class="label">
                消费力
              </div>
            </div>
            
            <div class="item">
              <div class="icon">
                <img src="./../../../assets/image/datasource/chart.png" alt="">
              </div>
              <div class="amount">
                <span>
                  <countTo :startVal='0' :endVal='41448240' :duration='5000'></countTo>
                </span>
                <span class="unit">
                  kg
                </span>
              </div>
              <div class="label">
                总销量
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <img src="./../../../assets/image/datasource/shop.png" alt="">
              </div>
              <div class="amount">
                <span>
                  <countTo :startVal='0' :endVal='30844' :duration='5000'></countTo>
                </span>
                <span class="unit">
                  家
                </span>
              </div>
              <div class="label">
                卖家数量
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <img src="./../../../assets/image/datasource/discuss.png" alt="">
              </div>
              <div class="amount">
                <span>
                  <countTo :startVal='0' :endVal='9777748' :duration='5000'></countTo>
                </span>
                <span class="unit">
                  个
                </span>
              </div>
              <div class="label">
                评论数
              </div>
            </div>
          </div>
        </transition>
        
        <div class="foot">
          <div class="submit-btnn" id="submitBtn">
              <button @click="toNextRouter">
                <div class="text">
                  同步生成各国家数据
                </div>
                <div class="subText">
                  Production data of other countries
                </div>
              </button>
          </div>
        </div>
      </div>
    </div>
    <div class="right-content">
      <Shopee :activeIndex="[]"></Shopee>
    </div>
    <stepDialog v-if="stepDialogStatus.show" :status="stepDialogStatus" @close="close"></stepDialog>
  </div>
</template>

<script>
  import Shopee from './shopee'
  import countTo from 'vue-count-to'
  import stepDialog from "../../../components/stepDialog";

  export default {
    components: {
      Shopee,
      countTo,
      stepDialog
    },
    data() {
      return {
        DriverInstance:null,
        stepDialogStatus:{
          show:false,
          in:false,
          start:3,
          end:5,
          page:'generate'
        }
      }
    },
    watch:{
      'stepDialogStatus.show':function (newv) {
        if(newv){
          document.body.style.overflow = 'hidden'
        }else {
          document.body.style.overflow = 'initial'
        }
      }
    },
    created() {
      if(!localStorage.getItem('generate')){
        setTimeout(()=>{
          this.stepDialogStatus.show = true
          this.stepDialogStatus.in = true
        },2000)
      }
    },
    mounted() {
      // this.stepStart()
    },
    beforeRouteLeave(to,from,next){
      if(this.DriverInstance){
        this.DriverInstance.reset()
      }
      next()
    },
    methods:{
      close(){
        this.stepDialogStatus.in = false
        setTimeout(()=>{
          this.stepDialogStatus.show = false
        },1000)
      },
      stepStart(){
        if(!localStorage.getItem('Generate')){
          this.DriverInstance = this.Driver('Generate')
          setTimeout(()=>{
            this.DriverInstance.start()
          },2000)
        }
      },
      toNextRouter(){
        this.$router.push({path:'/data/comparison',query:Object.assign(this.$route.query,{id:this.$route.query.id})})
      }
    }
  }
</script>

<style scoped lang="scss">
  @mixin title {
    margin-bottom: 10px;
    .text {
      font-size: 26px;
      font-weight: bold;
      line-height: 33px;
    }
    .subText {
      font-size: 12px;
      font-weight: 400;
      line-height: 15px;
      color: #999999;
    }
  }
  
  .generation-wrap {
    display: flex;
    
    .left-content {
      width: 400px;
      min-width: 400px;
      height: 722px;
      margin-right: 40px;
      background: #FFFFFF;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      opacity: 1;
      border-radius: 12px;
      
      .data-location {
        padding: 30px;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        
        .title {
          @include title;
          margin-bottom: 10px;
        }
        
        .content {
          flex-grow: 1;
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          overflow-y: auto;
          
          .item {
            padding-top: 32px;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 164px;
            height: 208px;
            text-align: center;
            margin-right: 10px;
            background: #FFFFFF;
            border: 2px solid #F1F1F1;
            border-radius: 12px;
            margin-bottom: 12px;
            
            &:nth-child(even) {
              margin-right: 0;
            }
            
            .icon {
              width: 68px;
              height: 68px;
              margin-bottom: 14px;
              text-align: center;
              background: linear-gradient(140deg, #70A0EB 0%, #005BE7 100%);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            
            .amount {
              span {
                height: 40px;
                font-size: 34px;
                font-family: Bahnschrift, serif;
                font-weight: bold;
                color: #666666;
                letter-spacing: -3px;
              }
              
              span.unit {
                font-size: 10px;
                font-family: Microsoft YaHei UI, serif;
                font-weight: 400;
                color: #999999;
              }
            }
            
            .label {
              font-size: 18px;
              font-weight: 400;
              line-height: 24px;
              color: #999999;
            }
          }
        }
        
        .foot {
          .submit-btnn {
            margin-top: 20px;
            width: 100%;
            text-align: center;
            
            button {
              width: 100%;
              height: 64px;
              background: linear-gradient(90deg, #70A0EB 0%, #005BE7 100%);
              box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
              opacity: 1;
              border-radius: 60px;
              
              .text {
                font-size: 22px;
                font-family: Microsoft YaHei UI;
                font-weight: 400;
                line-height: 26px;
                color: #FFFFFF;
              }
              
              .subText {
                font-size: 10px;
                font-weight: 400;
                line-height: 14px;
                color: #FFFFFF;
              }
            }
          }
        }
      }
    }
    
    .right-content {
      flex-grow: 1;
      flex-shrink: 1;
      height: 722px;
      background: #FFFFFF;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      opacity: 1;
      border-radius: 12px;
      overflow: hidden;
    }
  }


</style>
